export default {
  title: 'SEO',
  subtitle:
    'Passe Titel und Beschreibung an, die in Google-Suchergebnissen und Social-Media-Vorschauen erscheinen. Leer lassen, um die Standardwerte zu verwenden.',
  fields: {
    title: {
      label: 'Seitentitel',
      placeholder: 'z. B. Forza Napoli — authentische neapolitanische Pizza in München',
      help: 'Wird als Überschrift in Google-Ergebnissen und in Browser-Tabs angezeigt. Bis zu 255 Zeichen; für die beste Vorschau 50–60 Zeichen anstreben.',
    },
    description: {
      label: 'Meta-Beschreibung',
      placeholder: 'Kurze Beschreibung deines Restaurants, die unter dem Titel in den Suchergebnissen erscheint.',
      help: 'Bis zu 500 Zeichen; Google zeigt typischerweise 150–160 an. Hebe hervor, was dein Restaurant besonders macht.',
    },
  },
  buttons: {
    save: 'Speichern',
  },
  toasts: {
    saved: 'SEO-Einstellungen gespeichert',
    failed: 'SEO-Einstellungen konnten nicht gespeichert werden',
  },
};
